<style>
.center {
  margin: 20px 0 0 20px;
}
.self-left,
.self-right {
  float: left;
  width: 50%;
  height: 100%;
  font-color: #000;
}
._uq_box {
  display: flex;
  gap: 0 30px;
  padding: 10px 16px;
}
</style>

<template>
  <div class="app-container">
    <div style="padding: 10px 0 20px 30px;">
      <ut-button type="primary" @click="goBack">返回</ut-button>
    </div>
    <dev class="_uq_box">
      <dev class="self-left">
        <span style="margin-left:20px"
          ><b>应用列表（账号：{{ account }}）</b></span
        >
        <ut-table :source="userApplications" border>
          <ut-table-column title="应用名称" key="appId" index="appId" />
          <ut-table-column title="操作" inline-template>
            <div>
              <ut-button
                type="info"
                size="small"
                @click.native="editApplication($index, row)"
                >修改</ut-button
              >
            </div>
          </ut-table-column>
        </ut-table>
      </dev>
      <dev class="self-right">
        <span style="margin-left:20px"
          ><b>业务报警Key列表（账号：{{ account }}）</b></span
        >
        <ut-table :source="userAlarmKeys" border>
          <ut-table-column title="报警Key" key="alarmKey" index="alarmKey" />
          <ut-table-column title="操作" inline-template>
            <div>
              <ut-button
                type="info"
                size="small"
                @click.native="editBiz($index, row)"
                >修改</ut-button
              >
            </div>
          </ut-table-column>
        </ut-table>
      </dev>
    </dev>
  </div>
</template>

<script lang="babel">
export default {
  data () {
    return {
      account: this.$route.query.account,
      userApplications: [],
      userAlarmKeys: []
    }
  },
  methods: {
    goBack () {
      this.$router.push({ path: '/users' })
    },
    editApplication (idx, row) {
      var json = {
        path: '/apps/edit',
        query: {
          id: row.appId,
          callbackUrl: '/users/query?account=' + this.$route.query.account
        }
      }
      this.$router.push(json)
    },
    editBiz (idx, row) {
      var json = {
        path: '/bizs/edit',
        query: {
          id: row.alarmKeyId,
          callbackUrl: '/users/query?account=' + this.$route.query.account
        }
      }
      this.$router.push(json)
    }
  },
  created () {
    const { allPermiList } = this.$store.getters
    // eslint-disable-next-line no-undef
    const sysKey = BUILD_ENV === 'ali' ? 'argus-ali-users' : 'argus-users'
    if (!allPermiList.includes(sysKey)) {
      this.$router.push('/401')
    }
    // 应用加载
    this.$http({
      method: 'get',
      url: 'permission/' + this.$route.query.account + '/query'
    })
      .then(response => {
      // 这里使用了ES6的语法
        this.userApplications = response.data.userApplications
        this.userAlarmKeys = response.data.userAlarmKeys
      })
      .catch(error => {
        console.log(error) // 请求失败返回的数据
      })
  }
}
</script>
